var setBold = function setBold(strText) {
  var strConcatenateText = '';

  if (strText) {
    var arrTextArr = strText.split('~');

    if (arrTextArr.length > 0) {
      arrTextArr.forEach(function (arrText, iKey) {
        if (iKey % 2 === 1) {
          strConcatenateText += "<span class=\"boldCustomerServiceLink\">" + arrText + "</span>";
        } else {
          strConcatenateText += arrText;
        }
      });
    }
  }

  return strConcatenateText;
};

export default setBold;